import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import Container from "react-bootstrap/Container";
import Image from "react-bootstrap/Image";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import "animate.css";
import ApiHelper from "../../../../Helpers/ApiHelper";
import IconSvg from "../../../SharedComponents/IconSvg";
import { folderEnum } from "../../../../Helpers/EnumHelper";

const TestItemImage = forwardRef(
  (
    {
      q,
      n,
      SetAnswer,
      SetMediaClick,
      _isMediaRunning,
      _setIsMediaRunning,
      _startTime,
      SetUnAnsweredAnswerTime,
      isLastQuestion,
      goingTo,
      textEntryAnimation,
      answersEntryAnimation,
    },
    ref
  ) => {
    const [isMediaRunning, setIsMediaRunning] = useState(false);
    const [order, setOrder] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [selectedAnswer, setSelectedAnswer] = useState(q.answer || null); // Store selected answer
    const [textAnimationClassName, setTextAnimationClassName] = useState(textEntryAnimation);
    const [answersAnimationClassName, setAnswersAnimationClassName] = useState(answersEntryAnimation);

    const [mediaSize, setMediaSize] = useState({
      width: window.innerWidth <= 1200 ? 320 : 480,
      height: window.innerWidth <= 1200 ? 180 : 270,
    });

    useEffect(() => {
      if (order === q.order) return;
      if (!order) {
        setOrder(q.order);
        setStartTime(_startTime);
      } else if (q.order + 1 === order) {
        let timer = Math.ceil((new Date() - startTime) / 1000);
        SetUnAnsweredAnswerTime(q.order, timer);
        setOrder(q.order);
        setStartTime(_startTime);
      } else if (q.order - 1 === order) {
        setOrder(q.order);
        setStartTime(_startTime);
      }

      return () => {};
    }, [order, q.order, _startTime, startTime, SetUnAnsweredAnswerTime]);

    // ✅ Store media width & height as state

    // ✅ Update media size on window resize
    useEffect(() => {
      const handleResize = () => {
        setMediaSize({
          width: window.innerWidth <= 1200 ? 320 : 480,
          height: window.innerWidth <= 1200 ? 180 : 270,
        });
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    function timeout(delay) {
      return new Promise((res) => setTimeout(res, delay));
    }

    const ExitAnimation = async (goingTo) => {
      if (goingTo === "next") {
        setTextAnimationClassName("animate__backOutLeft");
        setAnswersAnimationClassName("animate__pulse");
      } else if (goingTo === "previous") {
        setTextAnimationClassName("animate__backOutRight");
        setAnswersAnimationClassName("animate__pulse");
      }
      await timeout(500);
    };

    useImperativeHandle(ref, () => ({
      ExitAnimation, // exposing this function
    }));

    let HandleAnswering = async (a) => {
      setSelectedAnswer(a); // Update selected answer in state
      let timer = Math.ceil((new Date() - new Date(_startTime)) / 1000);

      SetAnswer(q.order, a, n, null, timer);
    };

    let HandleAnswerButtonClass = (no) => {
      return `answering-button  ${selectedAnswer === no && " selected"}  `;
    };

    let HandleStartMedia = () => {
      if (q.mediaClickCount >= 2 || isMediaRunning) return;
      const media = document.getElementById("media");
      media.onended = function () {
        setIsMediaRunning(false);
        setIsMediaRunning(false);
      };
      media.play();
      if (!q.mediaClickCount) SetMediaClick(q.order, 1);
      else if (q.mediaClickCount === 1) SetMediaClick(q.order, 2);
      setIsMediaRunning(true);
      setIsMediaRunning(true);
    };

    const HandleQuestionImageFile = (fileName) => {
      if (fileName.endsWith(".mp3"))
        return (
          <>
            <div className="flex-center">
              <IconSvg icon="speaker" />
              <audio id="media" src={ApiHelper.cloudFrontURL + folderEnum.question + fileName}>
                <source src={ApiHelper.cloudFrontURL + folderEnum.question + fileName} type="audio/mpeg" />
              </audio>
            </div>
            <Button
              variant="primary"
              size="sm"
              disabled={isMediaRunning || q.mediaClickCount > 1}
              onClick={HandleStartMedia}
            >
              Başlat
            </Button>
            <span className="media-warning">
              Kalan Hak &nbsp;
              {!q.mediaClickCount ? 2 : 2 - q.mediaClickCount}
            </span>
          </>
        );
      else if (fileName.endsWith(".webm") || fileName.endsWith(".mp4"))
        return (
          <div>
            <div>
              <video
                id="media"
                width={mediaSize.width}
                height={mediaSize.height}
                src={ApiHelper.cloudFrontURL + folderEnum.question + fileName}
              >
                <source
                  src={ApiHelper.cloudFrontURL + folderEnum.question + fileName}
                  type={`video/${fileName.split(".").pop()}`}
                />
              </video>
            </div>

            <Button
              variant="primary"
              size="sm"
              disabled={isMediaRunning || q.mediaClickCount > 1}
              onClick={HandleStartMedia}
            >
              Başlat
            </Button>
            <span className="media-warning">
              Kalan Hak &nbsp;
              {!q.mediaClickCount ? 2 : 2 - q.mediaClickCount}
            </span>
          </div>
        );

      return (
        <Image
          src={ApiHelper.cloudFrontURL + folderEnum.question + fileName}
          // width={mediaSize.width}
          // height={mediaSize.height}
        />
      );
    };

    return (
      <>
        <div className="question-text-segment test-question-container  animate__animated  animate__faster">
          <div
            className={` animate__animated  animate__faster ${textAnimationClassName} text-color-gray-dark w-100`}
            id="question-text"
          >
            <Row className={"justify-content-evenly"}>
              {q?.imagePath && <Col xs={"auto"}>{HandleQuestionImageFile(q.imagePath)}</Col>}
              {q?.text && (
                <Col xs={12} sm={11} xxl={10} className={"mt-3"}>
                  {q?.text && q.text}
                </Col>
              )}
            </Row>
          </div>
        </div>

        <div className={`animate__animated   animate__faster  `}>
          <Row
            className={`justify-content-center animate__animated animate__faster ${answersAnimationClassName}`}
            style={{ paddingBottom: "100px" }}
          >
            {q &&
              [...(Array.isArray(q.options) ? q.options : [])]
                .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) // Sort a copy (don't mutate) by order
                .map((a, i) => {
                  return (
                    <Col key={i} xs="auto">
                      <Row className={"justify-content-center mx-0"}>
                        <button
                          id={a.id}
                          className={HandleAnswerButtonClass(a.id)}
                          onClick={() => HandleAnswering(a.id)}
                          style={{
                            height: "200px",
                            width: "200px",
                          }}
                          disabled={isMediaRunning}
                        >
                          {a.option && a.option}
                          {a.path && (
                            <Image
                              src={ApiHelper.cloudFrontURL + folderEnum.question + a.path}
                              width="170"
                              height="170"
                              style={{ borderRadius: "10px", pointerEvents: "none" }}
                            />
                          )}
                        </button>
                      </Row>
                    </Col>
                  );
                })}
          </Row>
        </div>
      </>
    );
  }
);
export default TestItemImage;
